import React, { useState } from "react";
import { Mic } from "lucide-react";
import VoiceModal from "./VoiceModal";

/**
 * Compact voice button — shown only when user is logged in. Opens VoiceModal.
 */
const VoiceButton = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                title="Voice ordering"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand-50 text-brand-700 ring-1 ring-brand-100 transition-colors hover:bg-brand-100"
                data-testid="nav-voice-btn"
                aria-label="Open voice ordering"
            >
                <Mic className="h-4 w-4" />
            </button>
            <VoiceModal open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default VoiceButton;
